import Image from 'next/image';
import { Modal, ModalContent } from 'ui/components/ModalV2/Modal';
import { ImageCarouselFeatureItem } from '@/client/whoopDotComContentfulClient';
import { NextGenerationLogoEyebrow } from '@/components/OPLComponents/NextGenerationCarousel/NextGenerationLogoEyebrow/NextGenerationLogoEyebrow';
import { CloseIcon } from 'ui/icons/close';
import { Info } from 'ui/icons/icons/Toast/info';
import RichTextRenderer from 'ui/components/RichTextRenderer/RichTextRenderer';

export interface NextGenModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  selectedItem: ImageCarouselFeatureItem;
}
export default function NextGenerationModal({
  isOpen,
  setIsOpen,
  selectedItem,
}: NextGenModalProps): JSX.Element | null {
  return (
    <Modal onOpenChange={setIsOpen} open={isOpen}>
      <ModalContent
        stickyHeader
        hideCloseButton
        headerContent={
          <div className='rounded-full bg-black pb-6'>
            <button
              className='absolute right-5 top-5 rounded-full bg-black p-2 text-white'
              onClick={() => setIsOpen(false)}
            >
              <CloseIcon pathStroke='white' title='Close modal' />
            </button>
          </div>
        }
        className='z-header h-[100dvh] max-h-[100dvh] min-h-[70dvh] w-full min-w-[100dvw] overflow-y-auto !px-0 pb-0 md:h-auto md:max-h-[80dvh] md:min-w-[600px] md:max-w-[80dvw] md:!px-6'
      >
        <div
          className='flex flex-col gap-4 px-10 pb-6 md:flex-row md:gap-24 md:px-16  md:pb-0'
          data-testid='next-generation-modal'
        >
          <div className='hidden items-start justify-center rounded-3xl bg-gray-50 px-5 md:sticky md:bottom-0 md:flex md:basis-2/5 md:self-end md:rounded-none md:bg-white md:p-0'>
            <Image
              className=''
              src={selectedItem.addAnItem.desktopMainImage.url}
              height={600}
              width={600}
              alt={selectedItem.addAnItem.desktopMainImage.fileName}
              data-testid='next-generation-modal-image-desktop'
            />
          </div>
          <div className='flex items-start justify-center rounded-3xl bg-gray-50 px-5 md:hidden md:basis-2/5 md:rounded-none md:bg-white md:p-0'>
            <Image
              className=''
              src={selectedItem.addAnItem.mobileMainImage.url}
              height={527}
              width={400}
              alt={selectedItem.addAnItem.mobileMainImage.fileName}
              data-testid='next-generation-modal-image-mobile'
            />
          </div>
          <div className='flex flex-col justify-center gap-7 pb-10 md:basis-3/5 md:gap-10'>
            <div className='flex flex-col gap-4 md:gap-8'>
              {selectedItem.addAnItem.disclaimer?.copy.json ? (
                <div className='mx-auto mb-4 flex w-[304px] items-center rounded-2xl bg-gray-400 p-4 md:w-full md:max-w-[1008px]'>
                  <div className='mr-4'>
                    <Info color='black' width={26} height={26} />
                  </div>
                  <div className='text-left'>
                    <RichTextRenderer
                      content={selectedItem.addAnItem.disclaimer?.copy.json}
                    />
                  </div>
                </div>
              ) : null}
              <NextGenerationLogoEyebrow item={selectedItem} />
              <h2 className='text-3xl font-semibold md:text-5xl'>
                {selectedItem.addAnItem.heading}
              </h2>
              <p className='font-regular text-lg md:text-2xl'>
                {selectedItem.addAnItem.subheading}
              </p>
            </div>
            <div className='flex flex-col gap-7 rounded-3xl bg-gray-50 p-7'>
              <p className='text-gray-70 text-sm font-semibold md:text-base'>
                {selectedItem.addAnItem.setAQuoteEyebrow}
              </p>
              <p className='font-regular text-2xl md:text-4xl'>
                {selectedItem.addAnItem.setAQuote}
              </p>
              <p className='text-lg font-semibold md:text-2xl'>
                {selectedItem.addAnItem.setAQuoteAuthor}
              </p>
            </div>
            <div>
              {selectedItem.addAnItem.finePrint?.content.json ? (
                <div className='text-gray-b50 text-base font-normal'>
                  <RichTextRenderer
                    content={selectedItem.addAnItem.finePrint?.content.json}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
}
